import type { FC } from 'react';
import React, { useContext, useState } from 'react';

import { ModalServiceContext, RicosContext } from './../../ricos-context';
import { resolveColorsPalette } from './../../wix-rich-content-common';
import { FloatingColorPicker } from './../../ui-components';

import { DEFAULT_PALETTE_BG, TABLE_COLOR_PICKER } from '../consts';

export type TableColorPickerProps = {
  referenceElement: HTMLElement | null;
  color: string | undefined;
  onChange: (color: string | undefined) => void;
};

export const TableColorPicker: FC<TableColorPickerProps> = ({
  referenceElement,
  color,
  onChange,
}) => {
  const { t } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);

  const [currentColor, setCurrentColor] = useState(color);

  const [userColors, setUserColors] = useState(() =>
    resolveColorsPalette(DEFAULT_PALETTE_BG, currentColor, 57)
  );

  const closeModal = () => {
    modalService.closeModal(TABLE_COLOR_PICKER);
  };

  return (
    <FloatingColorPicker
      title={t('Color_Picker_TextColorButton_Header')}
      currentColor={currentColor}
      userColors={userColors}
      onChange={({ type, color }) => {
        if (type === 'colorSelected') {
          onChange(color);
          setCurrentColor(color);
        }

        if (type === 'colorAdded') {
          setUserColors(prev => [...prev, color]);
          onChange(color);
          setCurrentColor(color);
        }
      }}
      onReset={() => {
        onChange(undefined);
        setCurrentColor(undefined);
      }}
      closeModal={closeModal}
      referenceElement={referenceElement}
      allowEmpty
    />
  );
};
